export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00461.41b01872.png";